import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { consigneeAPI } from '../services/api';
import './CustomerList.css';

function ConsigneeList() {
  const [consignees, setConsignees] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState('');

  useEffect(() => {
    fetchConsignees();
  }, []);

  const fetchConsignees = async () => {
    try {
      const response = await consigneeAPI.getAll();
      setConsignees(response.data);
    } catch (error) {
      console.error('Error fetching consignees:', error);
      alert('Failed to load consignees');
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (id, name) => {
    if (window.confirm(`Are you sure you want to delete consignee "${name}"?`)) {
      try {
        await consigneeAPI.delete(id);
        setConsignees(consignees.filter(c => c._id !== id));
        alert('Consignee deleted successfully');
      } catch (error) {
        console.error('Error deleting consignee:', error);
        alert('Failed to delete consignee. They may have associated invoices.');
      }
    }
  };

  const filteredConsignees = consignees.filter(consignee =>
    consignee.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
    (consignee.company && consignee.company.toLowerCase().includes(searchTerm.toLowerCase())) ||
    (consignee.email && consignee.email.toLowerCase().includes(searchTerm.toLowerCase()))
  );

  if (loading) {
    return <div className="loading">Loading consignees...</div>;
  }

  return (
    <div className="customer-list">
      <div className="page-header">
        <h2>Consignees</h2>
        <Link to="/consignees/new" className="btn btn-primary">
          Add New Consignee
        </Link>
      </div>

      <div className="search-bar">
        <input
          type="text"
          placeholder="Search consignees by name, company, or email..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          className="search-input"
        />
      </div>

      {filteredConsignees.length === 0 ? (
        <div className="empty-state">
          <p>No consignees found.</p>
          {searchTerm && <p>Try adjusting your search.</p>}
        </div>
      ) : (
        <table className="data-table">
          <thead>
            <tr>
              <th>Name</th>
              <th>Company</th>
              <th>Email</th>
              <th>Phone</th>
              <th>Location</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {filteredConsignees.map((consignee) => (
              <tr key={consignee._id}>
                <td>{consignee.name}</td>
                <td>{consignee.company || '-'}</td>
                <td>{consignee.email || '-'}</td>
                <td>{consignee.phone || '-'}</td>
                <td>
                  {consignee.address?.city && consignee.address?.state
                    ? `${consignee.address.city}, ${consignee.address.state}`
                    : '-'}
                </td>
                <td className="actions">
                  <Link to={`/consignees/edit/${consignee._id}`} className="btn btn-small btn-secondary">
                    Edit
                  </Link>
                  <button
                    onClick={() => handleDelete(consignee._id, consignee.name)}
                    className="btn btn-small btn-danger"
                  >
                    Delete
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}

export default ConsigneeList;
